<template>
  <div class="import-tool">
    <Modal v-model="visible" :title="title" :closable="false" :mask-closable="false" width="530" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div class="top-btn" v-if="progress > 0 && progress < 100" @click="small">缩小</div>
      <Icon type="md-close top-btn" v-else @click="close(curData, true)" />
      <div class="ivu-modal-footer">
        <div class="text1">导入进度</div>
        <div class="btn-box">
          <tooltip :txtInfo="curData.fileName" v-if="curData.fileName && curData.fileName.length > 20"></tooltip>
          <span v-else>{{ curData.fileName }}</span>
          <Upload
            ref="upload"
            :show-upload-list="false"
            class="upload-btn"
            :format="fileFormat"
            :max-size="2048"
            :before-upload="handleFormatError"
            accept=".xls,.xlsx"
            action="/"
          >
            <Button type="primary" ghost v-if="!curData.fileName">上传Excel</Button>
            <Button type="primary" ghost v-if="curData.fileName && progress == 0">重传Excel</Button>
            <Button type="primary" v-if="curData.fileName && progress == 100">继续上传Excel</Button>
          </Upload>
        </div>
      </div>
      <Progress :percent="progress" status="active" />
      <div class="progress-text" :class="{ 'show': curData.total }">
        <span>已导入{{ curData.success + curData.fail }}/{{ curData.total }}条</span>
        <span>成功{{ curData.success }}条</span>
        <span>失败{{ curData.fail }}条</span>
      </div>
      <div class="ivu-modal-footer">
        <div class="btn-box">
          <Button type="primary" @click="download(3)" v-if="curData.fail">导出失败文件</Button>
        </div>
      </div>
    </Modal>

    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
    <!-- 导入字段设置 -->
    <import-template-set ref="importTemplate"></import-template-set>
    <!-- 导入进度 -->
    <div class="import-small-list" v-if="visibleSmall">
      <div class="import-small" v-for="(bean, i) in list" :key="i" v-show="bean.batchNo != curData.batchNo">
        <div class="top-box">
          <div class="top-text">
            <img class="icon-status" v-if="bean.progress != 100" src="@static/images/icon_waitting.png" alt="" />
            <img class="icon-status" v-else src="@static/images/icon_success.png" alt="" />
            <div>
              <tooltip :txtInfo="'[' + bean.fileName + ']'" v-if="bean.fileName.length > 20"></tooltip>
              <span v-else>[{{ bean.fileName }}]</span>
              <span v-if="bean.progress != 100">导入处理中...</span>
              <span v-else-if="bean.fail">导入完成！</span>
              <span v-else>导入成功！</span>
            </div>
          </div>
          <div class="btn-box">
            <img class="top-btn" @click="close(bean, false)" src="@static/images/icon_close.png" alt="" />
          </div>
        </div>
        <div class="progress-text" v-if="bean.total">
          <span v-if="bean.progress != 100">导入在后台进行处理中，您可以正常进行其他操作或继续导入</span>
          <span v-else-if="!bean.fail && bean.success">您的数据都已成功完整导入</span>
          <span v-else
            >已导入成功<span class="r">{{ bean.success }}</span
            >条，失败<span class="f">{{ bean.fail }}</span
            >条<br />请下载异常文件后，修改您的异常数据再进行重新上传</span
          >
        </div>
        <Progress v-if="bean.progress != 100" :percent="bean.progress" status="active" />
        <p class="notice" v-if="bean.progress != 100">
          成功<span class="r">{{ bean.success }}</span
          >条，失败<span class="f">{{ bean.fail }}</span
          >条
        </p>
        <div style="text-align: center; margin-top: 4px">
          <Button v-if="bean.fail && bean.total && bean.progress == 100" type="error" class="btn-error" @click="download(3, bean.batchNo)">下载异常数据</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import importTemplateSet from './importConfig/importTemplateSet';
import confirmModal from '@/components/commons/confirmModal';
import tooltip from '@/components/commons/tooltip';
export default {
  props: {
    code: null,
    title: {
      default: 'title'
    }
  },
  components: {
    importTemplateSet,
    confirmModal,
    tooltip
  },
  data() {
    return {
      changeTab: false,
      fileFormat: ['xls', 'xlsx'],
      visible: false,
      visibleSmall: false,
      timerOpen: false, //当前是否在轮询
      data: {},
      file: {},
      params: {},
      progress: 0,
      curData: {},
      list: [] //进行中任务列表
    };
  },
  activated() {
    this.visibleSmall = true;
    if (!this.timerOpen) {
      this.startTask();
    }
  },
  deactivated() {
    this.visible = false;
    this.visibleSmall = false;
  },
  methods: {
    open(params) {
      this.params = params;
      this.curData = {};
      this.file = {};
      this.progress = 0;
      this.visible = true;
    },
    // 关闭弹窗 isBig 是否是关闭的大弹窗
    close(item, isBig) {
      console.log('item', item);
      if (item.fail && !isBig) {
        this.$refs.confirmModal
          .open({
            title: '提示',
            content: '关闭前是否导出失败文件？'
          })
          .then(() => {
            this.download(3, item.batchNo).then(() => {
              console.log(this.file.loading);
              if (!this.file.loading) {
                this.closeAjax(item.batchNo);
              }
              isBig && this.small();
            });
          })
          .catch(() => {
            isBig && this.small();
            item.batchNo && !this.file.loading && this.closeAjax(item.batchNo);
          });
      } else {
        isBig && this.small();
        item.batchNo && this.closeAjax(item.batchNo);
      }
    },
    // 缩小
    small() {
      this.visible = false;
      this.visibleSmall = true;
      this.params.batchNo = '';
      if (!this.timerOpen) {
        this.startTask();
      }
    },
    // 放大
    big(item) {
      this.visible = true;
      this.curData = item;
      this.progress = item.progress;
      this.params.batchNo = item.batchNo;
    },
    // 完成后删除任务
    closeAjax(batchNo) {
      this.$http({
        url: '/buz/importTask/close',
        type: 'GET',
        data: {
          code: this.code,
          batchNo: batchNo
        }
      }).then(() => {
        if (!this.timerOpen && !this.visible) {
          this.startTask();
        }
      });
    },
    // 1 模板 2成功 3失败
    download(type = 1, batchNo = this.curData.batchNo) {
      let url = this.params.template;
      if (type == 2) {
        //成功
        url = '/buz/importTask/successResult';
      } else if (type == 3) {
        //失败
        url = '/buz/importTask/errorResult';
      }
      return this.$http({
        url: url,
        type: type == 1 ? 'POST' : 'GET',
        forced: true,
        responseType: 'blob',
        All: true,
        data:
          type == 1
            ? []
            : {
                code: this.code,
                batchNo: batchNo
              }
      }).then(res => {
        if (res.headers['content-type'].includes('json')) {
          const { data } = res;
          const reader = new FileReader();
          reader.onload = () => {
            const { result } = reader;
            const errorInfos = JSON.parse(result);
            const { msg } = errorInfos;
            this.$notice.error(msg);
          };
          reader.onerror = err => {
            reject(err);
          };
          reader.readAsText(data);
          return;
        }
        this.$units.daochu(res);
      });
    },

    // 文件文件格式验证失败时的钩子，返回字段为 file, fileList
    handleFormatError(file) {
      const format = file.name.split('.')[1];
      if (!this.fileFormat.includes(format)) {
        this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
        return false;
      }
      this.curData = {
        fileName: file.name.split('.')[0]
      };
      if (this.file.loading) {
        this.file.loading = false;
      }
      console.log('this.params.batchNo',this.params.batchNo);
      if (this.params.batchNo) this.closeAjax(this.params.batchNo);
      this.file = file;
      this.progress = 0;
      this.params.batchNo = '';
      this.startUpload();
      return false;
    },
    // 开始上传
    startUpload() {
      this.changeTab = false;
      if (this.file.loading) {
        return;
      }
      this.file.loading = true;
      let formData = new FormData();
      formData.append('file', this.file);
      const closeNotice = this.$notice.loading('文件正在校验中，请耐心等待不要离开~');
      this.$http({
        url: this.params.upload,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
        apiPermissionCode: this.params.apiPermissionCode
      })
        .then(res => {
          closeNotice();
          if (this.visible) {
            this.params.batchNo = res.data;
          }
          if (!this.timerOpen) {
            console.log('this.params.batchNo',res.data)
            //当前如果没轮询启动轮询
            this.startTask(this.visible?res.data:'');
          }
        })
        .catch(e => {
          console.log(e);
          closeNotice();
          this.file.loading = false;
        });
    },
    // 开始轮询进度
    startTask(batchNo = this.params.batchNo) {
      this.$http({
        url: '/buz/importTask/progress',
        type: 'get',
        data: {
          code: this.code,
          batchNo: batchNo
        }
      })
        .then(res => {
          if (!this.params.batchNo && !this.visible) {
            this.curData = {};
          }
          let hasWait = false;
          console.log('---', this.params.batchNo);
          if (this.params.batchNo) {
            res.data.forEach(async item => {
              item.progress = (((item.fail + item.success) / item.total) * 100).toFixed(0) * 1;
              if (this.params.batchNo == item.batchNo) {
                this.curData = item;
                this.progress = item.progress;
                if (item.fail + item.success >= item.total && this.file.loading) {
                  this.$notice.msg(`成功${item.success}个 失败${item.fail}个`);
                  if (item.fail > 0) {
                    await this.download(3);
                  }
                  // this.closeAjax(item.batchNo);
                  this.file.loading = false;
                }
              }
              if (item.fail + item.success < item.total) {
                hasWait = true;
              }
            });
          } else {
            this.file.loading = !res.data.every(item => {
              return item.fail + item.success >= item.total;
            });
            hasWait = res.data.some(item => {
              return item.fail + item.success < item.total;
            });
            res.data.forEach(item => {
              item.progress = (((item.fail + item.success) / item.total) * 100).toFixed(0) * 1;
            });
          }
          if (!batchNo) {
            this.list = res.data;
          }
          if (!this.file.loading && (!this.list.length || !hasWait)) {
            this.timerOpen = false;
            return;
          }
          this.timerOpen = true;
          if (this.visibleSmall || this.visible) {
            window.setTimeout(() => {
              this.startTask();
            }, 1000);
          }
        })
        .catch(() => {
          this.timerOpen = true;
          if (!this.changeTab) {
            window.setTimeout(() => {
              this.startTask();
            }, 1000);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './importModal.scss';
</style>
